import React from "react";
import { LEGAL } from "../legal/content";
import { DocumentReader } from "../legal/DocumentReader";
import { fmtDate } from "../lib/format";
import { Card, Page, RowButton, Table } from "../design";

export function Legal() {
  const [openKey, setOpenKey] = React.useState<string | null>(null);
  const openDoc = LEGAL.find((d) => d.key === openKey);

  if (openDoc) {
    return (
      <DocumentReader blocks={openDoc.blocks} onBack={() => setOpenKey(null)} />
    );
  }

  return (
    <Page title="Terms & policies">
      <Card
        flush
        title="Documents"
        info="Changes are summarised in your inbox before they take effect."
      >
        <Table label="Terms and policies">
          <thead>
            <tr>
              <th>Document</th>
              <th>Version</th>
              <th>Updated</th>
            </tr>
          </thead>
          <tbody>
            {LEGAL.map((doc) => (
              <RowButton
                key={doc.key}
                label={doc.title}
                onOpen={() => setOpenKey(doc.key)}
              >
                <td>
                  <span className="strong">{doc.title}</span>
                  <span className="ds-cell-sub">{doc.desc}</span>
                </td>
                <td className="muted mono">{doc.version}</td>
                <td className="muted">{fmtDate(doc.updated)}</td>
              </RowButton>
            ))}
          </tbody>
        </Table>
      </Card>
    </Page>
  );
}
